// Navigation des Moduls `extension` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul extension.
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'extension',
  title: 'Bar for Chrome',
});
